<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSlotsManagementStore } from '../../model/slots-management/store'
import { useSalesQueueSlotsSave } from '../../api/slots-management/sales-queue.hook'
import SalesQueueSlotsTable from './SalesQueueSlotsTable.vue'
import SlotsDaysHeader from '../slots/SlotsDaysHeader.vue'

defineOptions({
  name: 'SalesQueueSlotsSection',
})

const store = useSlotsManagementStore()

const refTabs = computed(() => store.getSalesQueueDays.map(day => ({
  id: day.day_of_week,
  point: day.slots.some(slot => slot.is_enabled),
})))

const save = (): void => {
  void useSalesQueueSlotsSave()
}
</script>

<template>
  <CardAdmin
    title="Sales queue slots management"
    fullwidth
  >
    <template #header>
      <BtnPrimary
        text="Save"
        color="emerald"
        :disabled="store.isSaving"
        @click="save"
      />
    </template>
    <SlotsDaysHeader
      :tabs="refTabs"
      :selected="store.getDayTabId"
      @select="store.setDayTabId"
    />
    <SalesQueueSlotsTable
      v-for="day in store.getSalesQueueDays"
      :key="day.day_of_week"
      :day="day"
      :show="day.day_of_week === store.getDayTabId"
    />
  </CardAdmin>
</template>
